import { isTelemundoVertical } from 'lib/vertical';

const insertInlineNewsletterModule = (
  article,
  vertical,
) => (body) => {
  if (isTelemundoVertical(vertical)) return body;

  const changedBody = [...body];

  const inlineModule = {
    type: 'inlineNewsletter',
    props: { article, vertical },
  };

  changedBody.push(inlineModule);

  return changedBody;
};

export default insertInlineNewsletterModule;
